<template>
  <div class>
    <Toast />

    <div class="content-card">
      <h5>
        <b>Buat Retur Supplier Feedback</b>
      </h5>
      <div class="p-grid p-fluid p-mb-3 p-mt-4">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Nomor Bon</label>
          <div>
            <AutoComplete
              placeholder="Nomor Bon"
              :dropdown="true"
              :multiple="false"
              v-model="selectedDocNumber"
              :suggestions="filtered_suggestion"
              field="doc_number"
              @complete="searchBon"
            >
            </AutoComplete>
          </div>
          <small class="p-error" v-if="isError.warehouse_id">{{
            error_msg.warehouse_id
          }}</small>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Tanggal Bon</label>
          <div>
            <InputText
              type="date"
              :readonly="true"
              :disabled="true"
              v-model="today"
            />
          </div>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>Status</th>
                <th>Qty</th>
                <th>Harga (Rp)</th>
                <th>Total Harga (Rp)</th>
                <th>Hapus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  <AutoComplete
                    placeholder="Code"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.selected_item"
                    :suggestions="autoFiltered"
                    @complete="getItems($event)"
                    @input="chooseDropdownChanges(k)"
                    field="code"
                    :disabled="!selectedDocNumber"
                  >
                    <template #item="slotProps">
                      <div>{{ slotProps.item.name }}</div>
                      <div style="font-style: italic; font-size: 12px">
                        {{ slotProps.item.code }}
                      </div>
                    </template>
                  </AutoComplete>
                  <small class="p-error" v-if="isError.items[k].id">{{
                    error_msg.items[k].id
                  }}</small>
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    v-model="an_item.name"
                    placeholder="Name"
                  />
                </td>
                <td>
                  <AutoComplete
                    placeholder="Pilih tipe"
                    id="type"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.status"
                    :suggestions="autoFiltered"
                    @complete="searchType($event)"
                    field="name"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.qty"
                    @input="calculateTotal"
                  />
                </td>
                <td>
                  <InputNumber
                    :disabled="an_item.status.code !== 'REIMBURSEMENT'"
                    v-model="an_item.cap_price"
                    placeholder="0"
                    @input="calculateTotal"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.total_price"
                    :disabled="true"
                  />
                </td>
                <td class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label>Total</label>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_qty"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <Button
                    icon="pi pi-plus"
                    label="Tambah"
                    class="p-mr-2"
                    @click="addNewRow()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="p-grid p-justify-center">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges"
            :disabled="loading.createButton"
          >
            Buat
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      today: new Date().toISOString().split('T')[0],
      purchase_date: new Date().toISOString().split('T')[0],
      bon: null,
      autoFiltered: [],
      suppliers: [],
      filtered_suggestion: [],
      selected_supplier: '',
      items_checked: false,
      status_type: null,
      list_bon: [],
      doc_number: [],
      selectedDocNumber: '',
      status_types: [
        { id: 1, code: 'CUT_BONDS', name: 'Potong Bon' },
        { id: 2, code: 'REIMBURSEMENT', name: 'Ganti Uang' },
        { id: 3, code: 'REPLACE_BON', name: 'Ganti Barang' },
        { id: 4, code: 'WRITE_OFF', name: 'Pemutihan' }
      ],
      isError: {
        warehouse_id: false,
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false }]
      },
      error_msg: {
        warehouse_id: '',
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '' }]
      },
      items: [],
      list_retur: [],
      total_price: 0,
      total_qty: 0,
      items_temp: [
        {
          id: '',
          qty: 0,
          price: 0,
          status: ''
        }
      ],
      filters: {
        doc_date: '',
        doc_number: '',
        jenis_retur: ''
      },
      inputData: {
        doc_date: new Date().toISOString().split('T')[0],
        supplier_return_id: '',
        items: [
          {
            id: 0,
            qty: 0,
            price: 0,
            status: ''
          }
        ]
      },
      loading: {
        createButton: false
      }
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getListSupplierReturBon()
    this.getItems()
  },
  methods: {
    getListSupplierReturBon() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/supplier/return/list?is_done=true`
        )
        .then(response => {
          if (response.status === 200) {
            this.list_bon = response.data.data.supplier_return
            this.doc_list = this.list_bon.map(bon => ({
              id: bon.id,
              doc_number: bon.doc_number
            }))
          }
        })
    },

    searchBon(event) {
      const query = event.query.toLowerCase()
      this.filtered_suggestion = this.doc_list.filter(bon =>
        bon.doc_number.toLowerCase().includes(query)
      )
    },

    searchType(event) {
      this.autoFiltered = this.status_types.filter(types => {
        return (
          types.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          types.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },

    getStatusDisplayText(status) {
      if (status === 'REIMBURSEMENT') {
        return 'Ganti Uang'
      } else if (status === 'REPLACE_BON') {
        return 'Ganti Barang'
      } else if (status === 'CUT_BONDS') {
        return 'Potong Bon'
      } else if (status === 'WRITE_OFF') {
        return 'Pemutihan'
      } else {
        return status
      }
    },

    getItems(event) {
      let code = ''
      if (event != null && event.query != null) {
        code = event.query
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=15&show_empty_stock=true`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.autoFiltered = this.filterItems(event)
          }
        })
    },

    filterItems(event) {
      let query
      if (event != null && event.query != null) {
        query = event.query
      }
      const lowerCaseQuery = query.toLowerCase()
      return this.items.filter(item => {
        return (
          item.name.toLowerCase().indexOf(lowerCaseQuery) === 0 ||
          item.code.toLowerCase().indexOf(lowerCaseQuery) === 0
        )
      })
    },

    chooseDropdownChanges(index) {
      if (this.items_temp[index].selected_item instanceof Object) {
        this.isError.items[index].id = false

        this.inputData.items[index].id = this.items_temp[index].selected_item.id
        this.items_temp[index].cap_price = parseFloat(
          this.items_temp[index].selected_item.cap_price
        )
        this.items_temp[index].name = this.items_temp[index].selected_item.name
        this.items_temp[index].stock =
          this.items_temp[index].selected_item.stock

        this.calculateLineTotal(index)
      }
    },

    qtyChanges(index) {
      this.isError.items[index].qty = false
      this.inputData.items[index].qty = parseInt(this.items_temp[index].qty)
      this.calculateLineTotal(index)
    },

    calculateLineTotal(index) {
      let qty = parseInt(this.items_temp[index].qty) || 0

      this.items_temp[index].total = qty * this.items_temp[index].cap_price
      this.calculateTotal()
    },

    calculateTotal() {
      // Calculate total_qty and total_price for all items
      this.total_price = 0
      this.total_qty = 0

      this.items_temp.forEach(item => {
        // Parse item.qty and item.price to make sure they are numbers
        const qty = parseInt(item.qty) || 0
        const price = parseFloat(item.cap_price) || 0

        // Calculate total price for this item
        item.total_price = qty * price // Assign the multiplied value to the total_price field

        // Add to overall totals
        this.total_qty += qty
        this.total_price += item.total_price
      })
    },

    saveChanges() {
      if (this.selectedDocNumber && this.selectedDocNumber.id) {
        this.inputData.supplier_return_id = this.selectedDocNumber.id
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Please select a document number',
          life: 3000
        })
        return
      }
      this.inputData.doc_date = this.today
      this.inputData.items = this.items_temp.map(item => ({
        id: item.selected_item.id || item.id,
        qty: item.qty,
        price: item.cap_price,
        status: item.status.code
      }))
      for (let i = 0; i < this.inputData.items.length; i++) {
        if (
          !this.inputData.items[i].id <= 0 ||
          !this.inputData.items[i].id === '0'
        ) {
          this.items_checked = true
        } else {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'select item first'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'qty must > 0 and <= stock'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.loading.createButton = false
          this.$toast.add({
            severity: 'error',
            summary: 'Submit items failed',
            detail: 'Qty must be less than stock',
            life: 3000
          })
          return
        }
      }
      if (this.inputData.doc_date != '' && this.items_checked) {
        this.loading.createButton = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/supplier/result`,
            this.inputData
          )
          .then(response => {
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Submit items Success',
                detail: 'Congrats, those items have been submitted',
                life: 3000
              })

              this.total_price = 0
              this.total_qty = 0
              this.items_temp = [
                {
                  id: '',
                  qty: 0,
                  price: 0,
                  status: ''
                }
              ]
              this.inputData = {
                doc_date: '',
                supplier_return_id: '',
                items: [
                  {
                    id: 0,
                    qty: 0,
                    price: 0,
                    status: ''
                  }
                ]
              }
              setTimeout(() => {
                this.getListWarehouse()
                this.getItems()
              }, 500)
              this.loading.createButton = false
            } else {
              this.handleError(response)
            }
          })
          .catch(error => {
            if (error.response) {
              this.handleError(error.response)
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'An unexpected error occurred. Please try again.',
                life: 3000
              })
              this.loading.createButton = false
            }
          })
      }
    },

    handleError(response) {
      const errorMessage = response.data.message
      // Match the message and display appropriate error toast
      if (errorMessage === 'error.post.supplier_result') {
        this.$toast.add({
          severity: 'error',
          summary: 'Gagal Mengirim ',
          detail: 'Request Kosong',
          life: 3000
        })
      } else if (errorMessage === 'error.data_is_duplicate') {
        this.$toast.add({
          severity: 'error',
          summary: 'Duplicate Data',
          detail: 'Gagal Mengirim. Terdapat Duplikasi Data',
          life: 3000
        })
      } else if (errorMessage === 'error.qty_not_valid') {
        this.$toast.add({
          severity: 'error',
          summary: 'Invalid Quantity',
          detail: 'Quantity Tidak sama atau melebihi.',
          life: 3000
        })
      } else if (errorMessage === 'error.item_not_valid') {
        this.$toast.add({
          severity: 'error',
          summary: 'Invalid Item',
          detail: 'Item Tidak Ada',
          life: 3000
        })
      } else {
        // Default error message
        this.$toast.add({
          severity: 'error',
          summary: 'Submission Error',
          detail:
            'An unknown error occurred. Please check your input and try again.',
          life: 3000
        })
      }

      // Reset loading state
      this.loading.createButton = false
    },

    deleteRow(index, an_item) {
      let idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.inputData.items.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
      this.calculateTotal()
    },
    addNewRow() {
      this.items_temp.push({
        id: '',
        qty: 0,
        price: 0,
        status: ''
      })
      this.inputData.items.push({
        id: '',
        qty: 0,
        price: 0,
        status: ''
      })
      this.isError.items.push({ id: false, qty: false })
      this.error_msg.items.push({ id: '', qty: '' })
      this.calculateTotal()
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
